<template>
  <v-app>
    <Header
      :clipped="true"
      :drawer="false"
      :fixed="true"
      :title="title"
      ref="childComponent"
      v-if="showHeader"
    />

    <v-content>
      <search-menu :showSearchMenu="showSM" class="menu" />
      <router-view :key="$route.fullPath"></router-view>
      <div
        v-bind:class="showSM ? 'menu-overlay-enabled' : 'menu-overlay'"
        @click="close()"
      ></div>
    </v-content>
  </v-app>
</template>

<script>
import Header from "./layout/header";
import searchMenu from "./components/menu.vue";
export default {
  name: "App",
  components: { Header, searchMenu },

  data: () => ({
    title: process.env.VUE_APP_TITLE,
  }),

  computed: {
    showSM: function () {
      return this.$store.getters.GET_showSearchMenu.show;
    },
    showHeader: function () {
      return this.$store.getters.GET_showHeader;
    },
  },

  methods: {
    close() {
      let showSM = {
        show: false,
      };

      this.$store.commit("SET_showSearchMenu", showSM);
    },
  },

  created() {
    this.title = process.env.VUE_APP_TITLE;
    if (window.location.host.indexOf("-test") > -1) this.title += " TEST";
  },
};
</script>
<style scoped>
@import "./css/style.css";
@import "./css/profile.css";
</style>
